export default __webpack_public_path__ + "static/media/illustration-algostudy-n-w@3x.6e44de55.png";